import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { ApiError } from '../lib/api';
import { devLogin, useSession } from '../lib/session';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

const showDevLogin = import.meta.env.DEV;

function LoginPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const router = useRouter();
  const session = useSession();

  function handleMsalLogin() {
    setBusy(true);
    window.location.href = '/auth/login';
  }

  async function handleDevSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await devLogin(email);
      await session.refetch();
      await router.navigate({ to: '/' });
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : 'Login fehlgeschlagen';
      setError(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-md mt-16 rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
      <h1 className="text-xl font-semibold text-slate-900">Anmelden</h1>
      <p className="mt-1 text-sm text-slate-600">Mit dem M365-Konto von Busch GM einloggen.</p>
      <Button
        type="button"
        onClick={handleMsalLogin}
        disabled={busy}
        className="mt-6 w-full justify-center"
      >
        {busy ? 'Weiterleiten…' : 'Mit Microsoft anmelden'}
      </Button>

      {showDevLogin && (
        <details className="mt-6 rounded-md border border-slate-200 bg-slate-50 p-3">
          <summary className="cursor-pointer text-sm font-medium text-slate-700">
            Dev-Login (nur lokal)
          </summary>
          <form onSubmit={handleDevSubmit} className="mt-3 space-y-3">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-slate-700">
                E-Mail
              </label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1"
              />
            </div>
            {error && (
              <div className="rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
                {error}
              </div>
            )}
            <Button type="submit" disabled={busy} className="w-full justify-center">
              {busy ? 'Melde an…' : 'Dev-Login'}
            </Button>
          </form>
        </details>
      )}
    </div>
  );
}
